import React from 'react';
import Bugsnag from '@bugsnag/js';
import PriorityImageDownloader from './PriorityImageDownloader';

const downloader = new PriorityImageDownloader(15);

interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
    src: string;
    preload: boolean;
}

interface State {
    isLoaded: boolean;
}

class Img extends React.Component<Props, State> {
    state = {
        isLoaded: false,
    };

    constructor(props: Props) {
        super(props);

        let promise;
        if (!props.preload) {
            promise = downloader.downloadNow(props.src);
        } else {
            promise = downloader.downloadWithPriority(props.src, 1);
        }

        if (promise) {
            promise.then(() => this.setState({ isLoaded: true })).catch(Bugsnag.notify);
        } else {
            this.state.isLoaded = true;
        }
    }

    render() {
        // don't forward preload onto the img tag
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { preload, alt, ...props } = this.props;
        return this.state.isLoaded ? <img alt={alt} {...props} /> : null;
    }
}

export default Img;
